// components
import { AtHeader } from '@/components/atoms';
import { MlCard } from '@/components/molecules';

// types
import { ETagVariants } from '@/components/atoms/at-tag/at-tag.types';
import { EMlCardsTypes } from '@/components/molecules/ml-card/ml-card.types';
import { ISeriesModelHomeGridProps } from '../tm-home-plan-detail.types';
import { getCachedInitialProps } from '@/components/helpers/fetchInitialProps';

// css
import tmHomePageTemplate from '../tm-home-plan-detail.variants';
import classNames from 'classnames';

export const SeriesModelHomeGrid = async ({
  bottomSpacing = 'md',
  gridHeading,
  headingElement = 'h3',
  headingVariant = 'h2',
  modelHomes,
  topSpacing = 'md',
}: ISeriesModelHomeGridProps) => {
  const classes = tmHomePageTemplate({ topSpacing, bottomSpacing });

  // get all studios instead of passing as props
  const { studioData: allStudios } = await getCachedInitialProps();

  return (
    <div className={classNames('container', classes)}>
      <AtHeader
        element={headingElement}
        variant={headingVariant}
        className="mb-14"
      >
        {gridHeading ? gridHeading : 'Model Homes'}
      </AtHeader>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {modelHomes?.map((model, index) => {
          const floorPlan = model.FloorPlans?.[0];
          const studio = allStudios?.find((x) => x.Id == floorPlan?.StudioId);
          const studioName = studio?.CsName || studio?.Name;
          const city = studio?.City;
          const state = studio?.State;

          const tags =
            city && state
              ? [
                  {
                    children: `${studioName}, ${state}`,
                    variant: ETagVariants.LOCATION,
                  },
                ]
              : [];

          return (
            <MlCard
              key={`${model.Name}-${index}`}
              showFavouriteButton={false}
              variant={EMlCardsTypes.HOME_PLAN}
              href={model.cms ? model.cms.url : '/model-homes'}
              imageProps={{
                src: {
                  mobile:
                    model?.cms?.card_image?.mobile_image_url?.url ||
                    model.Image ||
                    '',
                  tablet:
                    model?.cms?.card_image?.mobile_image_url?.url ||
                    model.Image ||
                    '',
                  desktop:
                    model?.cms?.card_image?.mobile_image_url?.url ||
                    model.Image ||
                    '',
                },
                alt: '',
              }}
              homePlanProps={{
                name: model.Plan.Name,
                id: model.Id,
                description: `${model.ExteriorStyle.Name}`,
                features: [],
                tags,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
